import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Typography, Chip, Box, Tooltip } from '@mui/material';
import { TrendingUp as TrendingUpIcon, Info as InfoIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
const FindingNumberChip = styled(Chip)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold',
    minWidth: 32,
    height: 32,
    '& .MuiChip-label': {
        padding: '0 8px'
    }
}));
export const KeyFindingCard = ({ finding, defaultExpanded = false, onExpand, elevation = 1 }) => {
    // Always show full content - no expansion state needed
    return (_jsx(Card, { elevation: elevation, sx: { height: '100%', display: 'flex', flexDirection: 'column' }, children: _jsxs(CardContent, { sx: { pb: 2 }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }, children: [_jsx(FindingNumberChip, { label: finding.findingNumber, size: "small" }), _jsx(Typography, { variant: "h6", component: "h3", sx: { flex: 1, lineHeight: 1.3 }, children: finding.findingTitle }), getIconForFinding(finding.findingTitle)] }), _jsx(Typography, { variant: "body2", color: "text.secondary", paragraph: true, children: finding.findingDescription })] }) }));
};
function getIconForFinding(title) {
    const lowerTitle = title.toLowerCase();
    if (lowerTitle.includes('growth') || lowerTitle.includes('increase') || lowerTitle.includes('up')) {
        return (_jsx(Tooltip, { title: "Positive trend", children: _jsx(TrendingUpIcon, { color: "success" }) }));
    }
    if (lowerTitle.includes('decline') || lowerTitle.includes('decrease') || lowerTitle.includes('down')) {
        return (_jsx(Tooltip, { title: "Negative trend", children: _jsx(TrendingUpIcon, { color: "error", sx: { transform: 'rotate(180deg)' } }) }));
    }
    return (_jsx(Tooltip, { title: "Key insight", children: _jsx(InfoIcon, { color: "primary" }) }));
}
//# sourceMappingURL=KeyFindingCard.js.map